import { useNavigate } from '@tanstack/react-router'
import { SecondaryButton } from '@workspace/ui/components/dsm/secondary-button'
import { useInvestorContext } from '../../../../contexts/investor-guard'
import { copy } from '../../copy/investor-copy'
import { useWatchdogQuery } from '../../hooks/use-investor-assistant'

/** The watchdog on the Following page: whether it is on, how many startups are new, and the way to its tab. */
export function WatchdogBox() {
  const query = useWatchdogQuery()
  const { investor } = useInvestorContext()
  const navigate = useNavigate()
  const data = query.data
  if (!data) return null
  const fresh = data.matches.filter((match) => match.seenAt === null).length
  return (
    <section
      aria-label={copy('watchdog.tab')}
      className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-border bg-card/30 p-4"
    >
      <div className="space-y-0.5">
        <p className="text-sm font-semibold text-foreground">{copy('watchdog.tab')}</p>
        <p className="text-sm text-muted-foreground">
          {copy(data.paused ? 'watchdog.paused' : 'watchdog.on')}
          {fresh > 0 && ` · ${copy('watchdog.new', { n: fresh })}`}
        </p>
      </div>
      <SecondaryButton
        size="sm"
        onClick={() =>
          navigate({
            to: '/app/investor/$id/search',
            params: { id: investor.id },
            search: { tab: 'watchdog' },
          })
        }
      >
        {copy('watchdog.box.open')}
      </SecondaryButton>
    </section>
  )
}
